import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { LucideIcon } from "lucide-react";
import { PropsWithChildren } from "react";

interface StatCardProps extends PropsWithChildren {
  title: string;
  icon?: LucideIcon;
}

export function StatCard({ title, icon, children }: StatCardProps) {
  const Icon = icon;

  return (
    <Card>
      <CardHeader className="flex flex-row items-center justify-between space-y-0 p-0 px-6 pt-[18px] pb-2.5">
        <CardTitle className="text-sm font-normal text-gray-500">
          {title}
        </CardTitle>
        {Icon && <Icon className="h-5 w-5 text-gray-500" strokeWidth="1.5px" />}
      </CardHeader>
      <CardContent className="text-3xl font-medium p-0 px-6 pb-[18px]">
        {children}
      </CardContent>
    </Card>
  );
}
